import { HighlightIcon } from '@dev-spendesk/grapes';

import {
  getLogoUrlFromName,
  SupplierLogo,
} from 'src/core/common/components/SupplierLogo';

import { type FlattenedBudgetRow } from './helpers/misc';
import { getDimensionIcon } from '../../../budgets-by-dimensions/models/dimension';

export const RowIcon = ({ row }: { row: FlattenedBudgetRow }) => {
  if (row.dimension === 'root') {
    return null;
  }
  const logoUrl = row.dimensionName && getLogoUrlFromName(row.dimensionName);
  return (
    <div className="relative">
      <HighlightIcon size={32} {...getDimensionIcon(row.dimension)} />
      {row.dimension.type === 'supplier' && logoUrl && (
        <SupplierLogo
          name={row.label}
          src={logoUrl}
          size={16}
          className="absolute right-0 bottom-0"
        />
      )}
    </div>
  );
};
